import StbSurface from "@storeblocks/surface";
import styled from "styled-components";

export const SurfaceHeading = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.medium};
`;

export const SurfaceParagraph = styled.p`
  font-style: normal;
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  line-height: ${({ theme }) => theme.lineHeight.m};
  text-align: start;
`;

export const StyledSurface = styled(StbSurface)`
  background: ${({ theme }) => theme.surface.color};
  display: block;
  padding: ${({ theme }) => `${theme.spacing.sm}`};
`;
